export enum OrderTypeValues {
  GravyOrder = 'gravy:order',
  GiftCardOrder = 'giftcard:order',
  SweetpassOrder = 'sweetpass:order',
}
